import React from "react";
import { STORE_LINKS, ASSETS } from "../../data/landing";
import { useLanguage } from "../../i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();
  const f = t.footer;

  const links = [
    { label: f.about, href: "#about", testid: "footer-about" },
    { label: f.privacy, href: "#", testid: "footer-privacy" },
    { label: f.terms, href: "#", testid: "footer-terms" },
    { label: f.support, href: "#", testid: "footer-support" },
    {
      label: f.playStore,
      href: STORE_LINKS.googlePlay,
      testid: "footer-play-store",
      external: true,
    },
    {
      label: f.appStore,
      href: STORE_LINKS.appStore,
      testid: "footer-app-store",
      external: true,
    },
  ];

  return (
    <footer
      className="border-t border-[#7B1113]/8 bg-[#F6F2EA]"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 pb-28 md:py-16 md:pb-16">
        <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
          <div className="max-w-sm">
            <div className="flex items-center gap-3">
              <img
                src={ASSETS.logo}
                alt={t.brand}
                width="44"
                height="44"
                loading="lazy"
                className="h-11 w-11 rounded-full object-cover"
              />
              <span className="text-lg font-semibold tracking-tight text-[#2A1112]">
                {t.brand}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-[#5E4646]">
              {f.tagline}
            </p>
          </div>

          <nav aria-label="Footer" className="flex flex-wrap gap-x-8 gap-y-3">
            {links.map((link) => (
              <a
                key={link.testid}
                href={link.href}
                data-testid={link.testid}
                {...(link.external
                  ? { target: "_blank", rel: "noopener noreferrer" }
                  : {})}
                className="text-sm font-medium text-[#5E4646] transition-colors duration-300 hover:text-[#7B1113]"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="mt-10 border-t border-[#7B1113]/8 pt-6 text-center md:text-left">
          <p className="text-sm text-[#5E4646]">
            © {new Date().getFullYear()} {f.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
